exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-card[data-v-399a715e]{border:1px solid #ddd;margin-top:16px;padding:16px;border-radius:8px}.payment-card-title[data-v-399a715e]{font-size:20px;font-weight:500}.payment-currency-btn .btn__content[data-v-399a715e]{width:60px!important}.payment-methods[data-v-399a715e]{margin-bottom:20px;display:flex;align-items:center;cursor:pointer;border:1px solid #ddd;border-radius:16px;padding:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-399a715e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/chargeBalance.vue
// module id = 853
// module chunks = 0